import { Locale } from './locale';

/**
 * 多语言标签类型：每个枚举值对应一组语言翻译
 */
export type I18nLabels<T extends string> = Record<T, Record<Locale, string>>;

/**
 * 根据当前语言获取单个枚举标签
 */
export function getLabel<T extends string>(labels: I18nLabels<T>, key: T, locale: Locale): string {
  return labels[key]?.[locale] ?? labels[key]?.[Locale.ZH_CN] ?? key;
}

/**
 * 根据当前语言将 I18nLabels 降维为 Record<T, string>
 * 前端组件中使用，保持与原 Labels 相同的调用方式
 */
export function getLabelsByLocale<T extends string>(labels: I18nLabels<T>, locale: Locale): Record<T, string> {
  const result = {} as Record<T, string>;
  for (const key of Object.keys(labels) as T[]) {
    result[key] = labels[key]?.[locale] ?? labels[key]?.[Locale.ZH_CN] ?? key;
  }
  return result;
}

/**
 * 画面比例枚举
 */
export enum AspectRatio {
  SQUARE = '1:1',
  LANDSCAPE = '16:9',
  PORTRAIT = '9:16',
  STANDARD = '4:3',
  PORTRAIT_STANDARD = '3:4'
}

export const AspectRatioLabels: I18nLabels<AspectRatio> = {
  [AspectRatio.SQUARE]: { [Locale.ZH_CN]: '1:1 (正方形)', [Locale.EN_US]: '1:1 (Square)' },
  [AspectRatio.LANDSCAPE]: { [Locale.ZH_CN]: '16:9 (横屏)', [Locale.EN_US]: '16:9 (Landscape)' },
  [AspectRatio.PORTRAIT]: { [Locale.ZH_CN]: '9:16 (竖屏)', [Locale.EN_US]: '9:16 (Portrait)' },
  [AspectRatio.STANDARD]: { [Locale.ZH_CN]: '4:3 (标准)', [Locale.EN_US]: '4:3 (Standard)' },
  [AspectRatio.PORTRAIT_STANDARD]: { [Locale.ZH_CN]: '3:4 (竖版)', [Locale.EN_US]: '3:4 (Portrait Std)' },
};

/**
 * 画面清晰度枚举
 */
export enum Resolution {
  HD_720P = '720p',
  FHD_1080P = '1080p',
}

export const ResolutionLabels: I18nLabels<Resolution> = {
  [Resolution.HD_720P]: { [Locale.ZH_CN]: '720P', [Locale.EN_US]: '720P' },
  [Resolution.FHD_1080P]: { [Locale.ZH_CN]: '1080P', [Locale.EN_US]: '1080P' },
};
